import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';

import { environment } from '../../environments/environment';
import { AuthService } from '../auth/auth.service'
import { User } from '../users/user.model'
import { VersionService } from '../version.service'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input() hidden: boolean = false;

  signInUrl = this.authService.signInUrl;
  signedIn: boolean = false;
  currentUser: User;
  currentVersion: string = environment.version;
  latestVersion: string = environment.version;

  constructor(
    private router: Router,
    private authService: AuthService,
    private versionService: VersionService) { }

  ngOnInit() {
    this.signedIn = this.authService.signedIn
    this.currentUser = this.authService.currentUser

    Observable.fromEvent(window, 'focus').subscribe((event) => {
      this.versionService.getVersion().subscribe((version) => {
        this.latestVersion = version
      })
    })
  }

  onRefresh(event) {
    window.location.reload(true);
  }

}


// WEBPACK FOOTER //
// ./src/app/header/header.component.ts